import React, { Component } from 'react';
import { ITagJson } from '@scale/shared/types/tag';
import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

interface SelectOption {
  label: string;
  value: string;
}
interface ISelectTagProps {
  value?: SelectOption | SelectOption[];
  onChange?: ((value?: SelectOption) => void) | ((value?: SelectOption[]) => void);
  multi?: boolean;
  isClearable?: boolean;
  ignoreCase?: boolean;
  placeholder?: string;
  fullWidth?: boolean;
}
export default class SelectTag extends Component<ISelectTagProps> {
  async fetchTags(search: string) {
    if (!search) {
      return [];
    }

    try {
      const query = { method: 'GET', search };

      const results = await apiFetch(null, `corp-api/tags`, { query });

      const options = results.tags.map((tag: ITagJson) => {
        return {
          label: tag.name,
          value: tag._id,
        };
      });

      return {
        options,
      };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return [];
    }
  }

  render() {
    return (
      <div style={this.props.fullWidth ? {} : { width: '500px' }}>
        <Select
          loadOptions={this.fetchTags.bind(this)}
          ignoreCase={false}
          placeholder="Tag Name or ID"
          {...this.props}
        />
      </div>
    );
  }
}
